import ko from '@bower_components/knockout/dist/knockout';
ko.mapping = require('../../../node_modules/@bower_components/knockout-mapping/knockout.mapping');
import $ from 'jquery';
const jQuery = $;

/**
 * sum nums
 * @param  {Number} a first
 * @param  {Number} b second
 * @return {Number}   result
 */
function sum(a, b) {
  return a + b;
}

var tolerance = 1.2;

var FloorModel = function(floor, parent) {
  ko.mapping.fromJS(floor, {}, this);
  this.parent = parent;

  this.listRooms = ko.computed(function() {
    // var self = this;
    var a = this.rooms().filter(() => true);
    // i => i.area() * tolerance >= this.parent.sliderValue());
    return a;
  }, this);
};

var BuildingModel = function(building, parent) {
  ko.mapping.fromJS(building, {}, this);
  this.parent = parent;

  this.sliderValue = ko.computed(function() {
    return this.parent.sliderValue();
  }, this);

  this.floors = ko.observableArray(
    building.floors.map(i => new FloorModel(i, this))
  );

  this.sumArea = function(floor) {
    return floor.rooms().map(i => Number(i.area())).reduce(sum);
  };

  this.sumFloors = function() {
    return this.floors().map(i => this.sumArea(i)).reduce(sum);
  };

  this.markArea = function(area) {
    var val = this.sliderValue();
    return {area: area.toFixed(), fits: area * tolerance - val};
  };
};

var BuildingTypModel = function(buildingTyp, parent) {
  ko.mapping.fromJS(buildingTyp, {}, this);
  this.parent = parent;

  this.sliderValue = ko.computed(function() {
    return this.parent.sliderValues()[this.id()];
  }, this);

  this.buildings = ko.observableArray(
    buildingTyp.buildings.map(i => new BuildingModel(i, this))
  );

  this.area = ko.computed(function() {
    return this.buildings().map(i => i.sumFloors()).reduce(sum).toFixed();
  }, this);

  this.show = ko.computed(function() {
    var slider = this.sliderValue();

    if (slider === undefined) {
      return false;
    }

    var show = false;
    this.buildings().forEach(building => {
      // look if any sum of floors in buildings
      // is greather then sliderValue
      show |= building.sumFloors() * tolerance >= slider;
    });

    return show;
  }, this);
};

var LocationModel = function(location, parent) {
  ko.mapping.fromJS(location, {}, this);
  this.parent = parent;

  this.sliderValues = ko.computed(function() {
    return this.parent.sliderValues();
  }, this);

  // console.log(location.buildings);

  this.types = ko.observableArray(
    location.buildings.map(i => new BuildingTypModel(i, this))
  );

  this.planUrl = function(building, floor) {
    return '/#/' + this.slug() + '/' + building + '/' + floor;
  };

  this.show = ko.computed(function() {
    // init show variable
    var show = false;

    jQuery.each(this.types(), (i, typ) => {
      show |= typ.show();
    });

    return show;
  }, this);
};

var LocationsModel = function(items) {
  this.officeArea = ko.observable();
  this.workshopArea = ko.observable();
  this.storageArea = ko.observable();

  this.officeStatus = ko.observable();
  this.workshopStatus = ko.observable();
  this.storageStatus = ko.observable();

  this.refresh = function() {
    var data = this.locations().slice(0);
    this.locations([]);
    this.locations(data);
  };

  this.sliderValues = ko.computed(function() {
    return {
      2: this.officeStatus() ? this.officeArea() : undefined,
      3: this.workshopStatus() ? this.workshopArea() : undefined,
      5: this.storageStatus() ? this.storageArea() : undefined
    };
  }, this);

  this.locations = ko.observableArray(
    items.map(i => new LocationModel(i, this))
  );
};

export default LocationsModel;
